module.exports = __webpack_public_path__ + "static/img/giant-cage.f9eb7ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/giant-cage.jpg
// module id = lf/W
// module chunks = 1